import styled, { css } from 'styled-components';
// import { landingFeesTableMobile } from 'src/assets';
import OptionList from '../option-list/OptionList';
export const OptionsListWithHeaderContainer = styled.div `
  width: 100%;
  margin-bottom: 2rem;
  z-index: ${({ theme }) => theme.zIndex.medium};
`;
export const OptionListHeader = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;

  padding: 1.6rem 2.7rem;

  background-image: ${({ landingFeesTableMobile }) => `url(${landingFeesTableMobile})`};

  border-top-left-radius: ${({ theme }) => theme.borderRadius.high};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.high};

  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  background-repeat: no-repeat;
  background-size: cover;

  ${({ theme }) => theme.media.tabletL `
  padding: 3rem 3.3rem;
  text-align: left;
  justify-content: space-between;


`};
`;
export const CustomOptionList = styled(OptionList) `
  border-top-left-radius: unset;
  border-top-right-radius: unset;
  background-color: ${({ theme }) => theme.colors.surface.default};
  .description {
    width: 20rem;
  }
`;
export const OptionListHeading = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-right: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  height: 5rem;
  ${({ theme, title }) => !title
    ? css `
          border-top-left-radius: ${theme.borderRadius.high};
          border-top-right-radius: ${theme.borderRadius.high};
        `
    : ''}
`;
//# sourceMappingURL=styles.js.map